import { tv } from '~/utils/tv'

export const InputCounterinputVariants = tv({
  base: [
    'w-full bg-transparent text-center text-text-neutral-alternative tabular-nums outline-none placeholder:invisible focus-within:text-text-neutral',
    'disabled:cursor-not-allowed disabled:text-text-neutral-disabled',
    'read-only:pointer-events-none read-only:cursor-not-allowed read-only:text-text-neutral-readonly',
  ],
  variants: {
    hasError: {
      true: 'text-text-neutral-alternative',
    },
  },
})
